import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {Box, BoxContent, NoData, MainHeading} from '../../StyledComponents';
import WordCloud from 'react-d3-cloud';

/**
* Styled components
*/
const WordCloudViewContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  svg {
    opacity: 0.8;

  }

  @media only screen and (max-width: 991px) {
    min-height: 350px;
  }

  @media only screen and (max-width: 524px) {
    min-height: 320px;
  }
`;

/**
* Class WordCloudView
*/
class WordCloudView extends Component {
  constructor(props) {
      super(props);
      this.state = {};
  }
  componentDidMount() {
    const padding = 27;
    const height = document.getElementById('wordCloudContainer').clientHeight - (padding*2);
    const width = document.getElementById('wordCloudContainer').clientWidth - (padding*2);
    this.setState({ height, width });
  }
  prepareData(data) {
    const keyIn = "word";
    const keyOut ="text"
    const valueIn = "freq";
    const valueOut = "value";

    for (var i=0;i<data.length;i++) {
      data[i][valueOut] = data[i][valueIn];
      data[i][keyOut] = data[i][keyIn];
    };

    return data;
  }

  fontSizeMapper(data) {
    let sum = 0;
    let average = 0;
    let sizeFactor = 4;
    const valueIn = "freq";

    for (var i=0;i<data.length;i++) {

      sum += parseFloat(data[i][valueIn]);
    }
    average = sum/data.length;

    if (average < 100) {
      sizeFactor = 6;
    }
    if (average < 10) {
      sizeFactor = 15;
    }
    if (average < 5) {
      sizeFactor = 15;
    }
    return word => Math.log2(word.value) * sizeFactor;
  }

  render() {
      const { data, printBreak } = this.props;
      const placeholderData = {
          "type": "word cloud",
          "title": "Sentiment (Wordcloud)",
          "words": [
            {
              "word": "tele2",
              "freq": 122
            },
            {
              "word": "sverige",
              "freq": 93
            },
            {
              "word": "digitala",
              "freq": 84
            }
          ]
        };

      const _data = data || placeholderData;
      const disabled = !data;
      //const fontSizeMapper = word => Math.log2(word.value) * 4;

      return (
        <Box id="wordCloudContainer" className={printBreak ? 'print-page-break-after' : ''} {...this.props}>
          <WordCloudViewContainer>
              <MainHeading lessBottomMargin={true}>{this.props.title || _data.title /*disabled ? (this.props.title || _data.title):_data.title*/}</MainHeading>


            <BoxContent disabled={disabled} >
            {this.state.height ? <WordCloud
                data={this.prepareData(_data.words)}
                fontSizeMapper={this.fontSizeMapper(_data.words)}
                rotate={0}
                width={this.state.width}
                height={this.state.height}
                font={"Avenir,Tahoma,Arial,sans-serif"}
              />:''}

              {/*_data && (
                <TagCloudsContainer>
                  <TagCloud minSize={18}
                    maxSize={38}
                    colorOptions={selectColor}
                    tags={this.prepareData(_data.words)}
                  />
                </TagCloudsContainer>
              )*/}

            </BoxContent>
            {disabled && <NoData/>}
          </WordCloudViewContainer>
        </Box>
      );

  }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid
    };
}

export default connect(mapStateToProps)(WordCloudView);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/WordCloudView.js